export const BASE_URL = process.env.REACT_APP_API_URL || "https://backend-z22g.onrender.com";